import styled from "styled-components";

export const LearningPathModalWrapper = styled.div`
	margin: 0;
	padding: 0;
	.submit-button {
		width: 100%;
		justify-content: center;
	}

	.learning-path-modal {
		border-radius: 0;
		border: 30px solid var(--primary-green-600);
		background-color: var(--primary-green-100);

		.learning-path-modal-content {
			display: flex;
			flex-direction: column;
			gap: 24px;
			align-items: center;
			text-align: center;
		}

		.closeButtonWrapper {
			top: 10px;
			right: 10px;

			svg > path {
				stroke: var(--primary-forest-400);
				fill: var(--primary-forest-400);
				stroke-width: 2px;
			}
		}
	}
`;
